import React from 'react';
import { Link } from '@ambiguous/link';
export default function CardLogo({ content, image, title, url, url__props, url_text, bg_color }) {
    const { alt, id, url: src } = image || {};
    const blank = !!(url__props === null || url__props === void 0 ? void 0 : url__props.blank);
    const bg_styles = bg_color ? { style: { backgroundColor: bg_color } } : null;
    return (React.createElement("div", { className: "ltg-card-logo" },
        React.createElement("div", Object.assign({ className: "ltg-card" }, bg_styles),
            React.createElement(Anchor, { url: url, blank: blank, className: "ltg-card-img-wrap" },
                React.createElement("img", { src: src, alt: alt || title, className: "ltg-card-img" })),
            React.createElement("div", { className: "ltg-card-content-wrap" },
                title && (React.createElement("h4", { className: "ltg-card-title" }, title)),
                content && (React.createElement("div", { className: "ltg-card-content", dangerouslySetInnerHTML: { __html: content } })),
                url_text && (React.createElement(Link, { href: url, target: blank ? '_blank' : null, rel: blank ? 'noreferrer nofollow noopener' : null, className: "ltg-card-link" }, url_text))))));
}
function Anchor({ url, blank, children, className }) {
    if (url) {
        return (React.createElement(Link, { href: url, target: blank ? '_blank' : null, rel: blank ? 'noreferrer nofollow noopener' : null, className: className }, children));
    }
    return (React.createElement("div", { className: className }, children));
}
